import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import FeedbackPopup from '../Common/FeedbackPopup';
import FooterComponent from '../Common/FooterComponent';
import ExtensionNavbar from './ExtensionNavbar';
/* global gtag */

const affiliateSignupUrl = "https://easyimagetotext.lemonsqueezy.com/affiliates";

function SheetsExtensionAffiliateOnboarding(){

    const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

    const isShowConsole = process.env.NODE_ENV === 'development';

    const navigate = useNavigate();
    const location = useLocation();
    isShowConsole && console.log("Current Path:", location.pathname); 

    useEffect(() => {
        document.title = "Convert PDF to Google Sheets in 1 click | Convert PDF Bank Statement to CSV | 1-click PDF to Google Sheets Converter, PDF to CSV converter";
    }, []);
    
    const initiateAffiliateSignup = e => {
        //event tracker
            gtag('event', 'affiliate_clicked', {
                event_category: 'Button',
                event_label: 'Affiliate'
            });
        //
        try{
            window.open(affiliateSignupUrl, '_blank', 'noopener,noreferrer');
        }catch(err){
            console.log('error in initiateAffiliateSignup method: ', err);
            
        }
    }

    const openAffiliateKit = e => {
        try{
            window.open(
                'https://www.easyimagetotext.com/sheets-extension-affiliate-kit',
                "_blank"
            );
        }catch(err){
            console.log('error in openAffiliateKit method: ', err);
            
        }
    }

    const openPricingPage = e => {
        try{
            window.open(
                'https://www.easyimagetotext.com/sheets-extension-pricing',
                "_blank"
            );
        }catch(err){
            console.log('error in openPricingPage method: ', err);
            
        }
    }

    return(
        <div className='parentDiv'>
            <div className='mainDiv privacyPolicy'>
                <div className='header'>
                    <ExtensionNavbar />
                </div>
                <div className='contentDiv'>
                    <div className='containerDiv' style={{width: '80%'}}>
                        <div className='title'>Steps to Become an Affiliate</div>
                        <div className='contentBox' style={{alignItems: 'normal'}}>
                            <div className='content' style={{width: '90%', height: 'auto'}}>
                                <div style={{fontSize: '18px'}}>
                                    <ol className='affiliateOnboardingSteps'>
                                        <li>Sign in to <a href='https://affiliates.lemonsqueezy.com/' target="_blank" rel="noopener noreferrer">Lemon Squeezy Affiliate Hub</a></li>
                                        <li>Click <b>Become an affiliate</b> in the left panel</li>
                                        <li>Submit profile for approval</li>
                                        <li>Respond to the email from Lemon Squeezy after submission</li>
                                        <li>Approval happens within 1-2 days</li>
                                        <li>Now visit <a href='https://affiliates.lemonsqueezy.com/programs/easyimagetotext' target="_blank" rel="noopener noreferrer">easy image to text</a> affiliate program</li>
                                        <li>Submit affiliate request <i>(instant activation)</i></li>
                                        <li>Get your unique referral link and start sharing!</li>
                                        <li>Our <span style={{textDecoration: 'underline', color: '#551A8B', cursor: 'pointer'}} onClick={openAffiliateKit}>Affiliate Kit</span> has all you need</li>
                                        <li>If you need any help, reach out any time at 📧  <span className="emailId">support@easyimagetotext.com</span></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {showFeedbackPopup && <FeedbackPopup closeFeedbackPopup={() => setShowFeedbackPopup(false)}/>}
            </div>            
            <FooterComponent forSheetsExtension={true} setShowFeedbackPopup={setShowFeedbackPopup}/>
            {/* <div style={{position: 'sticky', bottom: '10px'}}>
                <a href={"https://affiliate.watch/affiliate/easy-image-to-text"} target="_blank" style={{display: 'inline-block', lineHeight: 0}}>
                    <img src={"https://affiliate.watch/api/affiliate-badge/2619/featured-purple-bg-white-text"} alt="Featured as a Top Affiliate Program on Affiliate.Watch" style={{height: '80px'}}/>
                </a>
            </div> */}
        </div>
    )
}

export default SheetsExtensionAffiliateOnboarding;